import createAttachmentsApi from './provider';

const JOB_POSTING_ATTACHMENT_TYPE_ID = 3;

const { get, add, edit, remove } = createAttachmentsApi(JOB_POSTING_ATTACHMENT_TYPE_ID);
export { get, add, edit, remove };